module.exports = __webpack_public_path__ + "static/media/iconSkolegarden.2adc3395.png";